import { cva } from 'class-variance-authority';

export const sheetVariants = cva(
  [
    'text-color-ref-text-strong',
    'gap-spacing-sys-spacing-16',
    'flex',
    'flex-col',
    'justify-between',
    'border-0',
    'bg-color-comp-modal-container',
    'overflow-hidden',
    'shadow-box-shadow-sys-high',
    'transition-all',
    'ease-in-out',
    'data-[state=open]:animate-in',
    'data-[state=closed]:animate-out',
  ],
  {
    variants: {
      side: {
        top: [
          'top-0',
          'border-b',
          'inset-x-0',
          'data-[state=open]:slide-in-from-top',
          'data-[state=closed]:slide-out-to-top',
        ],
        bottom: [
          'border-t',
          'bottom-0',
          'inset-x-0',
          'data-[state=open]:slide-in-from-bottom',
          'data-[state=closed]:slide-out-to-bottom',
        ],
        left: '',
        right: [
          'w-3/4',
          'sm:max-w-sm',
          'h-full',
          'right-0',
          'inset-y-0',
          'data-[state=open]:slide-in-from-right',
          'data-[state=closed]:slide-out-to-right',
        ],
      },
      fixed: {
        true: [
          'fixed',
          'z-50',
          'data-[state=open]:duration-500',
          'data-[state=closed]:duration-300',
        ],
        false: ['absolute', 'z-40', 'duration-500'],
      },
    },
    compoundVariants: [
      {
        side: 'left',
        fixed: false,
        class: [
          'inset-y-0',
          'left-0',
          'h-full',
          'w-3/4',
          'border-r',
          'sm:max-w-sm',
        ],
      },
      {
        side: 'left',
        fixed: true,
        class: [
          'w-3/4',
          'sm:max-w-sm',
          'h-full',
          'border-r',
          'left-0',
          'inset-y-0',
          'data-[state=open]:slide-in-from-left',
          'data-[state=closed]:slide-out-to-left',
        ],
      },
    ],
    defaultVariants: {
      side: 'right',
      fixed: true,
    },
  },
);
